export const customersPath = "/customers/";
export const customerPath = (id: string) => customersPath + id;
